import styled from "styled-components";

export const CustomWhatsappButton = styled.div`
  .MuiSvgIcon-root {
    color: #128c7e;
    font-size: 1.9rem;
  }
`;

export const CustomTitle = styled.label`
  font-size: 0.9rem;
`;
